import React, { useState, useEffect } from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Title from './Title';

import { COLORS } from '../../theme/muiTheme';

import { useAppSelector, useAppDispatch } from './../../hooks'
import { Auth, API } from 'aws-amplify'
import { getFundraisingAmbassadors } from '../../managers/redux/slices/fundraising';
import { reloadAuthAccount } from '../../managers/redux/slices/authAccount';
import { CircularProgress, Typography } from '@mui/material';

// Generate Order Data
function createData(
  id: number,
  date: string,
  name: string,
  shipTo: string,
  paymentMethod: string,
  amount: number,
) {
  return { id, date, name, shipTo, paymentMethod, amount };
}

const rows = [
  createData(
    0,
    '16 Mar, 2019',
    'Elvis Presley',
    'Tupelo, MS',
    'VISA ⠀•••• 3719',
    312.44,
  ),
  createData(
    1,
    '16 Mar, 2019',
    'Paul McCartney',
    'London, UK',
    'VISA ⠀•••• 2574',
    866.99,
  ),
  createData(2, '16 Mar, 2019', 'Tom Scholz', 'Boston, MA', 'MC ⠀•••• 1253', 100.81),
  createData(
    3,
    '16 Mar, 2019',
    'Michael Jackson',
    'Gary, IN',
    'AMEX ⠀•••• 2000',
    654.39,
  ),
  createData(
    4,
    '15 Mar, 2019',
    'Bruce Springsteen',
    'Long Branch, NJ',
    'VISA ⠀•••• 5919',
    212.79,
  ),
];

function preventDefault(event: React.MouseEvent) {
  event.preventDefault();
}

export default function Orders() {

  const dispatch = useAppDispatch()

  const fundraising = useAppSelector(state => state.fundraising)
  const authAccount = useAppSelector(state => state.authAccount)

  const [donorList, setDonorList] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    (async () => {
      if (authAccount.cognitoData) {
        if (fundraising.ambassadors == null) {
          dispatch(getFundraisingAmbassadors())
        }
      } else {
        await dispatch(reloadAuthAccount())
        if (fundraising.ambassadors == null) {
          dispatch(getFundraisingAmbassadors())
        }
      }
    })()
  }, [])

  useEffect(() => {
    (async () => {
      if (donorList == null && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile.organizationID) {
        const apiName = 'RESTfundraising';
        const path = '/fundraising/donations';

        setLoading(true)

        const user = await Auth.currentAuthenticatedUser()

        console.log(user)

        const response: any = await API.get(apiName, path, { "queryStringParameters": { "jwt": user.signInUserSession.idToken.jwtToken, organizationID: authAccount.selectedStaffProfile?.organizationID } });

        console.log(response)
        if (response && response.donations) {
          console.log(response.donations)
          setDonorList(response.donations)
        }

        setLoading(false)
      }
    })()
  }, [authAccount])

  return (
    <React.Fragment>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Email</TableCell>
            <TableCell align="left">Name</TableCell>
            <TableCell align="left">Phone Number</TableCell>
            <TableCell align="left">Address</TableCell>
            <TableCell align="left">Donation Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            donorList && donorList.length && donorList.length > 0 && !loading ?
              donorList.map((donation: any) => {
                return (
                  <TableRow
                    key={donation.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: COLORS.ICE } }}
                  // onClick={() => { history.push(`/admin/profile?id=${fundraisingProfile && fundraisingProfile.authAccount ? fundraisingProfile.authAccount.id : ''}`) }}
                  >
                    <TableCell align="left">
                      {donation.customer_email ? donation.customer_email : ''}
                    </TableCell>
                    <TableCell align="left">
                      {donation.donorName ? donation.donorName : ''}
                    </TableCell>
                    <TableCell align="left">
                      {donation.checkoutSession ? JSON.parse(donation.checkoutSession).customer_details.phone : ''}
                    </TableCell>
                    <TableCell align="left">
                      {donation.checkoutSession ? `${JSON.parse(donation.checkoutSession).customer_details.address.line1} ${JSON.parse(donation.checkoutSession).customer_details.address.city} ${JSON.parse(donation.checkoutSession).customer_details.address.state} ${JSON.parse(donation.checkoutSession).customer_details.address.postal_code}` : ''}
                    </TableCell>
                    <TableCell align="left">
                      {donation.checkoutSession ? `$${Number(JSON.parse(donation.checkoutSession).amount_total) / 100}` : ''}
                    </TableCell>
                  </TableRow>
                )
              })
              : donorList && donorList == [] && !loading ?
                <Typography variant="body1" className="m-3">No transactions yet</Typography>
                : loading && donorList == null ?
                  <div className="w-100 d-flex flex-row justify-content-center align-items-center p-5">
                    <CircularProgress />
                  </div>
                  :
                  <div />
          }
        </TableBody>
      </Table>
      {/* <Link color="primary" href="#" onClick={preventDefault} sx={{ mt: 3 }}>
        See more transactions
      </Link> */}
    </React.Fragment>
  );
}